import React, { useState } from "react"
import { Button, Icon } from '@arnsbogroup/react-voicearchive'
import messages from "./messages"
import { FormattedMessage, useIntl } from 'react-intl'
import useCurrentUser from 'hooks/useCurrentUser'
import useApi from 'hooks/useApi'
import SubmittedTable from './components/SubmittedTable'
import AddVersion from './components/AddVersion'
import Comments from './components/Comments'

const AuditionScopePage = ({ orderId, refetchOrder }) => {
  const { formatMessage } = useIntl()
  const { roles } = useCurrentUser()
  const [entries,,, refetchAuditionScope] = useApi(`/rest/v2/order/${orderId}/audition-scope-overview`)
  const [addVersion, setAddVersion] = useState(false)
  const [duplicateEntry, setDuplicateEntry] = useState(null)
  const domain = window.location.hostname
  const protocol = window.location.protocol

  const copyUrl = (type) => {
    const url = type == 'overview' ? `${protocol}//${domain}/orders/${orderId}/overview` : entries?.publicLink
    navigator.clipboard.writeText(url).then(function() {
      toastr.success(formatMessage(messages.copySuccess))
    }, function(err) {
      toastr.error(err)
    });
  }

  return (
    <div className="bg-gray-50 h-full w-full">
      <div className='bg-white h-full'>
        {!addVersion && !duplicateEntry ? (
          <>
            <div className="group flex justify-between space-x-2 cursor-alias">
              <Comments orderId={orderId}/>
              {(roles.includes('coordinator') || roles.includes('sales')) &&
                <div
                  className="p-2 flex justify-between items-center space-x-2 cursor-pointer"
                  onClick={() => copyUrl('overview')}
                >
                  <label className="truncate w-full grow text-gray-700 text-xs  cursor-pointer">
                    <FormattedMessage {...messages.copyCustomerOverviewLink} />
                  </label>
                  <Icon
                    icon={['fas', 'copy']}
                    className="text-primary"
                  />
                </div>
              }
              <div
                className="p-2 flex justify-between items-center space-x-2 cursor-pointer"
                onClick={() => copyUrl('public')}
              >
                <label className="truncate w-full grow text-gray-700 text-xs  cursor-pointer">
                  <FormattedMessage {...messages.copyCustomerPublicLink} />
                </label>
                <Icon
                  icon={['fas', 'copy']}
                  className="text-primary"
                />
              </div>
            </div>
            <div>
              <SubmittedTable
                orderId={orderId}
                entries={entries} 
                refetch={() => refetchAuditionScope()} 
                onDuplicate={(entry) => {
                  setDuplicateEntry(entry)
                  setAddVersion(true)
                }} />
            </div>
            {(roles.includes('coordinator') || roles.includes('sales')) &&
              <>
                <div className="text-right p-2">
                  <Button size="sm" onClick={() => setAddVersion(true)}>
                    <FormattedMessage {...messages.createVersion} />
                  </Button>
                </div>
              </>
            }
          </>
        ) : (
          <AddVersion
            onVersionClose={() => {
              setAddVersion(false);
              setDuplicateEntry(null);
              refetchAuditionScope();
            }}
            defaultDeadline={entries?.defaultDeadline || (new Date().getTime() + 24 * 60 * 60) / 1000}
            duplicateEntry={duplicateEntry}
            orderId={orderId}
            refetchOrder={refetchOrder}
          />
        )
        }
      </div>
    </div>
  )
}

export default AuditionScopePage
